import { TFunction } from 'i18next';
import { z } from 'zod';

export const getRoleSchema = (t: TFunction) =>
  z.object({
    role: z.string().nonempty(t('common.validation.fieldRequired')),
    description: z.string().nonempty(t('common.validation.fieldRequired')),
    permissions: z.array(z.string()).optional(),
  });
